//#region src/presentation/components/modal-views/register-modal-view.ts
var register = {};
var registerModalView = (key, creator) => {
	register[key] = creator;
};
var retrieveModalView = (key) => {
	return key ? register[key] : null;
};
//#endregion
export { registerModalView, retrieveModalView };

//# sourceMappingURL=register-modal-view.js.map